<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
@if (isScreenSmall) {
    <fuse-vertical-navigation
        class="dark bg-gray-900 print:hidden"
        [mode]="'over'"
        [name]="'mainNavigation'"
        [navigation]="user?.id ? navigation.default : !!guestUser ? navigation.guest : navigation.public"
        [opened]="false">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            <div class="page-header-logo enterprise-page-header-logo page-header-logo-vertical">
                <div class="logo"></div>
            </div>
        </ng-container>
    </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex flex-col flex-auto items-center w-full min-w-0" role="main">

    <!-- Header -->
    <!-- "h-16 sm:h-20 md:h-3" -->
    <div class="site-header z-49 sticky top-0 flex flex-col flex-0 justify-center w-full overflow-hidden shadow dark:shadow-none print:hidden">
        <!-- Top bar -->
        <div class="site-header-top relative dark flex flex-auto justify-center w-full px-4 md:px-8 page-header">
            <div class="site-header-top-inner flex items-center w-full max-w-360 h-12 sm:h-14">

                <!-- Navigation toggle button -->
                @if (isScreenSmall) {
                    <button
                        class="mr-4"
                        mat-icon-button
                        (click)="toggleNavigation('mainNavigation')">
                        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                    </button>
                }

                <!-- Logo -->
                <!-- @if (!isScreenSmall) { -->
                    <div class="invisible md:visible page-header-logo enterprise-page-header-logo page-header-logo-horizontal">
                        <div class="logo-left"></div>
                        <div class="logo-right"></div>
                    </div>
                <!-- } -->

                <!-- Components -->
                <div class="flex items-center pl-2 ml-auto mr-16 lg:mr-0 space-x-0.5 sm:space-x-2">
                    <!-- <languages></languages> -->
                    <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
                    <!-- <search [appearance]="'bar'"></search> -->
                    <!-- <shortcuts></shortcuts> -->
                    <!-- <messages></messages> -->
                    <!-- <notifications></notifications> -->
                    <!-- <button
                        class="lg:hidden"
                        mat-icon-button
                        (click)="quickChat.toggle()">
                        <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
                    </button> -->
                    <user></user>
                </div>
            </div>
        </div>

        <!-- Bottom bar -->
        @if (!isScreenSmall) {
            <div class="site-header-bottom flex flex-auto justify-center px-4 md:px-8 bg-card dark:bg-gray-700">
                <div class="site-header-bottom-inner relative flex items-center w-full max-w-360 h-16">
                    <fuse-horizontal-navigation
                        class="-mx-4"
                        [name]="'mainNavigation'"
                        [navigation]="user?.id ? navigation.default : !!guestUser ? navigation.guest : navigation.public"></fuse-horizontal-navigation>
                </div>
            </div>
        }
    </div>

    <!-- Content -->
    <div class="site-content relative flex flex-auto w-full">
        <ng-container *ngIf="true">
            <router-outlet></router-outlet>
        </ng-container>
    </div>

    <!-- Footer -->
    <div class="footer-outer z-49 sticky bottom-0 w-full px-6 md:px-8 border-t bg-card print:hidden" role="contentinfo">
        <div class="footer-inner w-full sm:flex sm:items-center h-14 sm:h-10 pt-2 sm:p-0">
            <iapply-version />
            <app-footer-links />
        </div>
    </div>
</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
